import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { getStorefrontUrl } from '~/helpers/getStorefrontUrl';
import storage from '~/storage';

export type useClientsArgs = {
  companyUuid?: string;
};

const storeToken = (token: string) => {
  try {
    window.sessionStorage.setItem('token', token);
  } catch (e) {
    // Fallback to a custom storage mechanism
    storage({ token });
  }
};

const fetchToken = async (companyUuid?: string) => {
  const response = await axios.get(
    getStorefrontUrl(`/api/v1/clients/${companyUuid}/credentials`).toString(),
  );

  const token = response.data[0];

  if (token) {
    storeToken(token);
  }

  return token;
};

export const useClients = ({ companyUuid }: useClientsArgs) => {
  const query = useQuery({
    queryKey: ['token', companyUuid],
    queryFn: () => fetchToken(companyUuid),
    retry: 3,
    retryDelay: (attempt) => Math.min(attempt * 1000, 3000),
    enabled: !!companyUuid,
    refetchOnWindowFocus: true,
    staleTime: 6 * 60 * 60 * 1000,
  });

  return { token: query.data, ...query };
};
